import { render, staticRenderFns } from "./EvolucoesPorData.vue?vue&type=template&id=6e99e5a8&"
import script from "./EvolucoesPorData.vue?vue&type=script&lang=js&"
export * from "./EvolucoesPorData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports